import type { AnalyticsEventPayload } from "@swiggy-private/analytics/dist/interfaces";
import { ObjectNames, ScreenNames, sendEvent } from "@swiggy-private/portal-dineout-context";
import type { IDigitalMenuConfigData, IEventPayload } from "@swiggy-private/portal-dineout-context";
import { getV2ConfigFlags } from "@swiggy-private/portal-dineout-ui";

export interface IAgeGateAnalyticsParams {
    eventFn: (payload: AnalyticsEventPayload) => void;
    restaurantId: string;
    tableId: string;
    ldaAgeThreshold: number;
    // Full menu config (has `version`) so we can report isV2Config in the context JSON.
    config: IDigitalMenuConfigData | null;
}

const getAnalyticsData = (
    { eventFn, restaurantId, tableId, ldaAgeThreshold, config }: IAgeGateAnalyticsParams,
    objectName: string,
): IEventPayload => {
    const { isV2 } = getV2ConfigFlags(config);
    return {
        eventFn,
        screenName: ScreenNames.AGE_CONSENT,
        objectName,
        objectPosition: "1",
        extraParams: {
            restaurant_id: restaurantId,
        },
        context: JSON.stringify({
            restaurantId,
            ldaAgeThreshold,
            isV2Config: isV2,
            tableId,
        }),
    };
};

// screen-view on DO-QR-AgeConsent — fires when the consent page renders.
export const sendAgeConsentScreenViewEvent = (args: IAgeGateAnalyticsParams) => {
    sendEvent(getAnalyticsData(args, "-"));
};

// click on consent-agree-cta — user taps "I agree".
export const sendAgeConsentAgreeEvent = (args: IAgeGateAnalyticsParams) => {
    sendEvent(getAnalyticsData(args, ObjectNames.CONSENT_AGREE_CTA));
};

// click on consent-cancel-cta — user taps "Cancel" / denies.
export const sendAgeConsentCancelEvent = (args: IAgeGateAnalyticsParams) => {
    sendEvent(getAnalyticsData(args, ObjectNames.CONSENT_CANCEL_CTA));
};
